import {API} from '../../networking/http'
import {QueryMethod} from '../helpers/types'
import {parseServiceNotice} from './helpers'
import {ServiceNotice} from './types'

export type GetServiceNoticeQuery = QueryMethod<undefined, undefined, ServiceNotice | null>

const FIVE_MINUTES = 1000 * 60 * 5

export const SERVICE_NOTICE_ENDPOINT = 'service-notice?app=WBA'

export const getServiceNoticeQuery: GetServiceNoticeQuery = (options) => ({
  queryKey: ['getServiceNoticeQuery'],
  staleTime: FIVE_MINUTES,
  refetchInterval: FIVE_MINUTES,
  refetchOnWindowFocus: true,
  retry: false,
  ...options,
  // 204, 404 and any failure all mean "no notice" — never surface an error to the member.
  queryFn: () =>
    API.get<undefined, unknown>(SERVICE_NOTICE_ENDPOINT)
      .then((res) => (res.status === 200 ? parseServiceNotice(res.data) : null))
      .catch(() => null),
})
